// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_BuscarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/formas_pagamento/buscar/<id>
 *
 * Returns a single payment method row (from config_formas_pagamento), with
 * forma_pagamento_nome translated in-place by translateObjectProperty.
 *
 * Wire shape: dados is a single FormaPagamentoRow object.
 *
 * @see FormasPagamento_FormaPagamentoRow
 * @see Formas_pagamento_model::get()
 */
import type { FormasPagamento_FormaPagamentoRow } from './FormasPagamento_FormaPagamentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type FormasPagamento_BuscarResponseDados = FormasPagamento_FormaPagamentoRow;

export type FormasPagamento_BuscarResponse = ApiResponse<FormasPagamento_BuscarResponseDados>;

registerResponseContract('FormasPagamento_BuscarResponse', {
  forma_pagamento_id:                   { type: 'number',  required: true },
  forma_pagamento_possui_taxas:         { type: 'number',  required: false },
  forma_pagamento_aceita_parcelado:     { type: 'number',  required: false },
  forma_pagamento_nome:                 { type: 'string',  required: true },
  forma_pagamento_taxa_mensal:          { type: 'number',  required: false },
  forma_pagamento_taxa_transacao:       { type: 'number',  required: false },
  forma_pagamento_taxa_transacao_tipo:  { type: 'number',  required: false },
  background_color:                     { type: 'string',  required: false },
  forma_pagamento_codigo:               { type: 'string',  required: false },
  forma_pagamento_parcelas_max:         { type: 'number',  required: false },
  forma_pagamento_parcelas_max_efetivo: { type: 'number',  required: false },
  forma_pagamento_dias_para_receber:    { type: 'number',  required: false },
})
